<template>
  <ValidationObserver v-slot="{invalid}">
    <b-modal
      v-model="isModalOpened.isOpen"
      :ok-disabled="invalid"
      ok-title="Send"
      title="Test Email"
      size="lg"
      @hidden="onHide"
      @ok.prevent="sendEmail"
    >
      <content-spinner :show="isLoading" />
      <b-form v-if="!isLoading">
        <b-form-group
          v-for="field of formFields"
          :key="field.id"
          :label="field.label"
        >
          <ValidationProvider
            v-if="field.type !== 'textarea'"
            v-slot="{touched, valid, errors}"
            :rules="getValidationRulesByInputType(field.type)"
            :name="field.label"
          >
            <b-form-input
              v-model="field.value"
              :type="field.type"
              :state="!touched ? null : valid"
            />
            <span class="error_message">{{ errors[0] }}</span>
          </ValidationProvider>

          <ValidationProvider
            v-else
            v-slot="{touched, valid, errors}"
            rules="required"
          >
            <b-form-textarea
              v-model="field.value"
              :state="!touched ? null : valid"
              rows="5"
              no-resize
            />
            <span class="error_message">{{ errors[0] }}</span>
          </ValidationProvider>
        </b-form-group>
      </b-form>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '@/core/components/ContentSpinner.vue';
const {mapState, mapActions} = createNamespacedHelpers('systemInfo');

export default {
  name: 'TestEmailModal',
  components: {ContentSpinner},
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...mapState({
      isModalOpened: state => state.systemSettings.testEmailModal,
      formFields: state => state.systemSettings.testEmailModal.fields,
      data: state => state.systemSettings.data,
      requestData: state => state.systemSettings.requestData,
    }),
  },
  methods: {
    ...mapActions([
      'setTestEmailModalState',
      'sendTestEmail',
      'collectSystemSettingsRequestData',
    ]),
    onHide() {
      this.setTestEmailModalState(false);
    },
    getValidationRulesByInputType(type) {
      return type === 'text' || type === 'password' ? 'required' : 'email|required';
    },
    async sendEmail() {
      this.isLoading = true;
      const currentItem = this.data.find(el => el.cardId === 'adpConfig');

      const modalValues = {
        to: '',
        subject: '',
        message: '',
      };
      for(const field in modalValues) {
        this.formFields.forEach(el => {
          if(el.id === field) {
            modalValues[field] = el.value;
          }
        });
      }

      this.collectSystemSettingsRequestData({
        item: 'adpConfig',
        fields: currentItem.items,
        isModal: true,
        modalValues,
      });
      const isSuccess = await this.sendTestEmail(this.requestData);

      this.$toasted[isSuccess ? 'success' : 'error'](
        isSuccess
          ? `Test email to "${modalValues.to}" was successfully sent`
          : 'An error occurred during the sending process, please try again.',
        {duration: TOASTER_DURATION},
      );
      this.isLoading = false;
      this.onHide();
    },
  },
};
</script>

<style scoped lang="scss">
.form-control:valid.form-control.is-valid {
  border: 1px solid #132f5b;
  background-image: none;
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba(19, 47, 91, 0.25);
  }
}
.error_message {
  position: absolute;
  margin-top: 2px;
  font-size: 10px;
  color: red;
}
</style>